import React, { useEffect } from "react";
import { MyGroup } from ".";
import { useGroup } from "../context/GroupContext";

const MyExplore = () => {
  const { groups, setLoadMyGroups, loadMyGroups } = useGroup();

  useEffect(() => {
    if(loadMyGroups) setLoadMyGroups(false);
    return () => { }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {(groups && groups.length > 0) ? <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        { groups.map(group => (<MyGroup data={group}  key={groups.indexOf(group)} button="Join" />)) }
      </div> : <div className="h-full mt-8 flex justify-center flex-col items-center">
        <h4 className="text-center">
          No Records Yet
        </h4>
      </div>}
    </>
  );
};

export default MyExplore;
